import './index-1880c860.js';
export { a as addIcons } from './utils-bc896e4b.js';
